module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('sub-tabs', {
    attrs: {
      "nomeSessao": "Agendamento",
      "tabs": _vm.tabs
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-xs1": "",
      "xs5": "",
      "offset-md1": "",
      "md5": ""
    }
  }, [(_vm.showNewBtn) ? _c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.newSchedule($event)
      }
    }
  }, [_c('span', {
    staticClass: "pr-1"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_circle_outline")])], 1), _vm._v("\n          Novo Agendamento\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    staticClass: "searchInput",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "label": "Pesquisar agendamentos",
      "append-icon": "search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('schedule-modal'), _vm._v(" "), _c('orders-list')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c73b79a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/index.vue
// module id = 740
// module chunks = 0